import { createAction } from 'redux-actions';
import { Map as ImmutableMap } from 'immutable';

import { rootUiActions, rootUiTypes } from 'companion-app-components/flux/root-ui';

export const DIALOG_TYPE = 'DELETE_REMINDER_DIALOG';

export const showDeleteReminderDialog = createAction(
  rootUiActions.createDialog.toString(),
  (txn, wrapperId = '') => rootUiTypes.mkRootUiData({
    type: DIALOG_TYPE,
    allowNesting: true,
    props: ImmutableMap({
      txn,
      wrapperId,
    }),
  }),
);
